import type { ReactNode } from 'react';

/**
 * Timeline MVP stage: visual group header with rail + node.
 * Architecture note: a full continuous timeline can later wrap stages
 * without touching the task list rendering.
 */
export function TimelineStage({ label, count, children }: { label: string; count: number; children: ReactNode }) {
  return (
    <div className="tp-timeline-stage">
      <div className="tp-timeline-stage__rail">
        <div className="tp-timeline-stage__node" />
      </div>
      <div className="tp-timeline-stage__content">
        <div className="tp-timeline-stage__header">
          <span className="tp-timeline-stage__label">{label}</span>
          <span className="tp-timeline-stage__count">({count})</span>
        </div>
        {children}
      </div>
    </div>
  );
}
